module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-emails"
  }, [_c('h3', {
    staticClass: "h3 mt0"
  }, [_vm._v("Email Logs")]), _vm._v(" "), _c('module-spinner', {
    attrs: {
      "active": _vm.loading,
      "floating": true
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.emailLogsLength > 0) ? _c('div', {
    key: "emails-table"
  }, [_c('module-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.emailLogs.results,
      "row-click": true
    },
    on: {
      "row-click": _vm.onRowClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-emails__more"
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Showing "), _c('strong', [_vm._v(_vm._s(_vm.emailLogsLength))]), _vm._v(" of "), _c('strong', [_vm._v(_vm._s(_vm.emailLogsTotal))]), _vm._v(" Results")]), _vm._v(" "), (_vm.emailLogs.next) ? _c('module-button', {
    attrs: {
      "button": "primary",
      "label": "Load more",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.getNextPage($event)
      }
    }
  }) : _vm._e()], 1)], 1) : (_vm.emailLogsLength === 0 && !_vm.loading) ? _c('p', {
    staticClass: "fw-bold mt2"
  }, [_vm._v("No Email Logs")]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7912cd8a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/dashboard/EmailLogs.vue
// module id = 356
// module chunks = 0